import { Component, HostBinding, ViewChild } from '@angular/core';
import { ModalWindowComponent } from 'ag-common-svc/lib/components/modal-window/modal-window.component';
import { Attendee } from 'ag-common-svc/lib/utils/attendees';
import { INVITEE_OUTCOME_STATUS_LOOKUP, InviteeStatus, InviteeStatusMap, Messages } from 'ag-common-lib/public-api';
import { UpdateInviteeOutcomeStatusModalService } from './update-invitee-outcome-status-modal.service';
import { confirm } from 'devextreme/ui/dialog';

interface UpdateInviteeOutcomeStatusModalContext {
  conferenceDbId: string;
  attendees: Attendee[];
  defaultOutcomeStatus?: InviteeStatus;
}

@Component({
  selector: 'ag-crm-update-invitee-outcome-status-modal',
  templateUrl: './update-invitee-outcome-status-modal.component.html',
  styleUrls: ['./update-invitee-outcome-status-modal.component.scss'],
})
export class UpdateInviteeOutcomeStatusModalComponent {
  @HostBinding('class') className = 'update-invitee-outcome-status-modal';
  @ViewChild('modalRef', { static: false }) modalComponent: ModalWindowComponent;

  protected readonly inProgress$ = this.updateInviteeOutcomeStatusModalService.inProgress$;
  protected readonly inviteeOutcomeStatusLookup = INVITEE_OUTCOME_STATUS_LOOKUP;
  protected selectedOutcomeStatus: InviteeStatus = InviteeStatus.attended;
  protected attendeesCount = 0;
  protected readonly Messages = Messages;

  private attendees: Attendee[] = [];
  private conferenceDbId: string;

  constructor(private updateInviteeOutcomeStatusModalService: UpdateInviteeOutcomeStatusModalService) {}

  showModal(context: UpdateInviteeOutcomeStatusModalContext): void {
    this.conferenceDbId = context?.conferenceDbId;
    this.attendees = context?.attendees ?? [];
    this.attendeesCount = this.attendees.length;
    this.selectedOutcomeStatus = context?.defaultOutcomeStatus ?? InviteeStatus.attended;

    this.modalComponent?.showModal();
  }

  protected handleSave = async () => {
    if (!this.attendeesCount) {
      this.modalComponent?.hideModal();
      return;
    }

    const selectedStatusLabel = InviteeStatusMap.get(this.selectedOutcomeStatus) ?? this.selectedOutcomeStatus;
    const attendeesCountLabel = this.attendeesCount === 1 ? 'invitee' : 'invitees';
    const message = `Are you sure want to change outcome status for ${this.attendeesCount} ${attendeesCountLabel} to "${selectedStatusLabel}"?`;
    const confirmed = await confirm(`<i>${message}</i>`, 'Confirm');

    if (!confirmed) {
      return;
    }

    await this.updateInviteeOutcomeStatusModalService
      .updateInviteeOutcomeStatus(this.conferenceDbId, this.attendees, this.selectedOutcomeStatus)
      .finally(() => {
        this.modalComponent?.hideModal();
      });
  };
}
